import { render, staticRenderFns } from "./proHouse.vue?vue&type=template&id=3923f0da&scoped=true&"
import script from "./proHouse.vue?vue&type=script&lang=js&"
export * from "./proHouse.vue?vue&type=script&lang=js&"
import style0 from "./proHouse.vue?vue&type=style&index=0&id=3923f0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923f0da",
  null
  
)

export default component.exports